/**
 * Convert a string to kebab case, 'foo-bar'
 * @function string.kebabCase
 * @param {String} str
 * @returns {String}
 */
export { default } from 'lodash/kebabCase';
